// extracted by mini-css-extract-plugin
export default {"container":"style_container__p0MZQ","footer":"style_footer__Q2osB","item-list":"style_item-list__y6WFZ","item":"style_item__pjT4T"};